<template>
  <div class="chart-name-top liberated-gas-chart-title-wrap" :class="extraClass">
    <span
      ref="titleTrigger"
      class="liberated-gas-chart-title-trigger"
      :class="{ 'is-truncated': isTruncated }"
      @mouseenter="showTooltip"
      @mouseleave="hideTooltip"
    >
      <h6 ref="titleText">{{ title }}</h6>
    </span>
    <Teleport to="body">
      <div
        v-if="tooltipVisible"
        class="liberated-gas-title-tooltip"
        :style="tooltipStyle"
        role="tooltip"
      >
        {{ title }}
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: "ChartTitleTooltip",
  props: {
    title: {
      type: String,
      default: "",
    },
    extraClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isTruncated: false,
      tooltipVisible: false,
      tooltipStyle: {
        top: "0px",
        left: "0px",
      },
    };
  },
  watch: {
    title() {
      this.$nextTick(this.checkTruncation);
    },
  },
  mounted() {
    this.$nextTick(this.checkTruncation);
    if (typeof ResizeObserver !== "undefined" && this.$refs.titleTrigger) {
      this.resizeObserver = new ResizeObserver(() => this.checkTruncation());
      this.resizeObserver.observe(this.$refs.titleTrigger);
    }
  },
  beforeUnmount() {
    this.resizeObserver?.disconnect();
  },
  methods: {
    checkTruncation() {
      const el = this.$refs.titleText;
      if (!el) {
        this.isTruncated = false;
        return;
      }
      this.isTruncated =
        el.scrollWidth > el.clientWidth + 1 ||
        el.scrollHeight > el.clientHeight + 1;
    },
    showTooltip(event) {
      if (!this.isTruncated) return;

      const rect = event.currentTarget.getBoundingClientRect();
      this.tooltipStyle = {
        top: `${rect.bottom + 6}px`,
        left: `${rect.left}px`,
      };
      this.tooltipVisible = true;
    },
    hideTooltip() {
      this.tooltipVisible = false;
    },
  },
};
</script>
